if (typeof SpinnerComponent !== 'function') {
	class SpinnerComponent extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.render();
			document.addEventListener('show-spinner', this.show.bind(this));
		}

		render() {
			this.innerHTML = `
                <div class="spinner">
                    <div class="spinner-inner"></div>
                </div>
            `;
		}

		show(event) {
			const spinner = this.querySelector('.spinner');

			spinner.style.display = 'block';

			setTimeout(function () {
				spinner.style.display = 'none';
			}, 1000);
		}
	}

	if (typeof customElements.get('spinner-component') == 'undefined') {
		customElements.define('spinner-component', SpinnerComponent);
	}
}
